import { GetParameterCommand, GetParameterCommandOutput, SSMClient, SSMClientConfig } from '@aws-sdk/client-ssm';

import ENVIRONMENT_VARIABLES from '../../constants/environmentVariables';
import { getAWSServiceCredentials } from '../authUtils';
import { logger } from '../logger';

/**
 * Retrieves a parameter value from AWS Systems Manager Parameter Store
 * Uses caching to reduce API calls for frequently accessed parameters
 *
 * @param parameterName The name of the parameter to retrieve
 * @param region Optional AWS region to use for the SSM client. If not provided, uses the default region from environment variables
 * @returns The value of the parameter as a string
 */
export const retrieveParameter = async (parameterName: string, region?: string): Promise<string> => {
  try {
    // Parameter not in cache or expired, fetch from SSM
    const ssmClientConfig: SSMClientConfig = {
      region: region || ENVIRONMENT_VARIABLES.env.Region,
      credentials: await getAWSServiceCredentials(),
    };

    const ssmClient = new SSMClient(ssmClientConfig);
    const command = new GetParameterCommand({
      Name: parameterName,
      WithDecryption: true,
    });

    const response: GetParameterCommandOutput = await ssmClient.send(command);
    const parameterValue = response.Parameter?.Value || '';

    return parameterValue;
  } catch (error) {
    logger.error(`Error retrieving parameter ${parameterName} from SSM:`, { error: error });
    throw error;
  }
};
